
import React, { useEffect, useRef, useState } from "react";
import './Main.css';
import SaveOrder from '../assets/saveOrder.png';
import QuickBilling from '../assets/quickBilling.png';
import ReportIcon from '../assets/report.png';
import InventoryIcon from '../assets/inventory.png';
import SabkaPOSImg1 from '../assets/sabkaPOS-Img1.png';
import SabkaPOSImg2 from '../assets/sabkaPOS-Img2.png';

const POSSystem = () => {

    const [mobileView, setMobileView]: any = useState<boolean>(
        window.innerWidth <= 768
    );

    useEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 768)
                setMobileView(true);
            else
                setMobileView(false);
        }
        window.addEventListener("resize", updateSize);
    }, [mobileView]);

    return (
        <div style={{ background: '#fff' }} id="posSystem">
            <div className="mainServiceContainer">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width:mobileView?'100%':'45%',gap:mobileView?10:0 }}>
                    <img style={{width:mobileView?120:'14.75vw'}} src={SabkaPOSImg1} alt="" />
                    <img style={{width:mobileView?120:'14.4vw'}} src={SabkaPOSImg2} alt="" />
                </div>
                <div style={{ width:mobileView?'100%':'55%',display:'flex',flexDirection:'column',justifyContent:'center' }}>
                    <h1 style={{fontSize:mobileView?26:'3.25vw',color:'#000',fontWeight:'bold',letterSpacing:2,textAlign:mobileView?'center':'left'}}>Sabka POS System</h1>
                    <div className="serviceDescription">
                    Sabka POS is an all-in-one solution for retailers, offering an extensive toolkit of management features that enable a smooth and swift setup for businesses.
<br /><br />
                        While a typical point-of-sale system integrates products, sales, and receipt generation, Sabka POS takes it a step further by providing additional services like  reports, daybook, expense management and purchase and inventory control. It’s a simple yet comprehensive solution!
                    </div>
                </div>
            </div>
        </div>
    );
};

export default POSSystem;
